import { SnackbarContent } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import moment from 'moment-timezone';
import * as React from 'react';
import { Subscription } from 'rxjs';
import { medicationNotification$ } from '../Config/ApplicationConfig';
import styles from './GlobalSnackbar.module.scss';
import { Nullable } from './Types';

const MinDisplayTime = 1000;

export type SnackbarState = {
    open: boolean;
    message: string;
    messageDisplayTime: Nullable<Date>;
    variant: SnackBarVariant;
};

export enum SnackBarVariant {
    Normal,
    Error,
    Success
}

export class GlobalSnackbar extends React.Component<Record<string, unknown>, SnackbarState> {
    private notifications$$: Nullable<Subscription> = null;

    constructor(props: Record<string, unknown>) {
        super(props);

        this.state = {
            open: false,
            message: '',
            messageDisplayTime: null,
            variant: SnackBarVariant.Normal
        };
    }

    componentDidMount() {
        this.notifications$$ = medicationNotification$.subscribe(notification => {
            if (notification.type === 'display') {
                this.displayMessage(notification.message);
            } else if (notification.type === 'error') {
                this.displayError(notification.message);
            } else if (notification.type === 'success') {
                this.displaySuccess(notification.message);
            }
        });
    }

    componentWillUnmount() {
        if (this.notifications$$) {
            this.notifications$$.unsubscribe();
        }
    }

    public render() {
        let snackBarVariant = '';

        if (this.state.variant === SnackBarVariant.Error) {
            snackBarVariant = styles.errorSnackbar;
        }

        if (this.state.variant === SnackBarVariant.Success) {
            snackBarVariant = styles.successSnackbar;
        }

        return (
            <>
                {this.props.children}
                <Snackbar
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={this.state.open}
                    onClose={this.handleClose}
                    ContentProps={{
                        'aria-describedby': 'message-id'
                    }}
                >
                    <SnackbarContent message={this.state.message} className={snackBarVariant} />
                </Snackbar>
            </>
        );
    }

    private handleClose = () => {
        if (this.state.messageDisplayTime) {
            const displayTime = moment().diff(moment(this.state.messageDisplayTime));
            if (displayTime > MinDisplayTime)
                this.setState({
                    open: false,
                    variant: SnackBarVariant.Normal,
                    messageDisplayTime: null,
                    message: ''
                });
        } else {
            this.setState({
                open: false,
                variant: SnackBarVariant.Normal,
                messageDisplayTime: null,
                message: ''
            });
        }
    };

    private displayError = (message: string) => {
        this.setState({
            message,
            variant: SnackBarVariant.Error,
            messageDisplayTime: new Date(),
            open: true
        });
    };

    private displayMessage = (message: string) => {
        this.setState({
            message,
            variant: SnackBarVariant.Normal,
            messageDisplayTime: new Date(),
            open: true
        });
    };
    private displaySuccess = (message: string) => {
        this.setState({
            message,
            variant: SnackBarVariant.Success,
            messageDisplayTime: new Date(),
            open: true
        });
    };
}
